// Путь: D:\QR\QR-WEB\dashboard\src\components\Business\CampaignsList.jsx
// Название: Campaigns List - Professional UI
// Версия: 7.0.0
// Дата: 27.01.2026 15:00

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';

// ============================================
// СЕКЦИЯ: Стили
// ============================================
const styles = {
  page: {
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px'
  },
  headerInfo: {
    flex: 1
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 4px 0'
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    margin: 0
  },
  headerActions: {
    display: 'flex',
    gap: '12px'
  },
  btnRefresh: {
    padding: '10px 16px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    background: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666',
    transition: 'all 0.2s'
  },
  btnCreate: {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #00c853 0%, #00a843 100%)',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 2px 8px rgba(0,200,83,0.3)',
    transition: 'all 0.2s'
  },
  statsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
    marginBottom: '24px'
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    border: '2px solid transparent'
  },
  statCardActive: {
    borderColor: '#00c853',
    background: '#f0fff4'
  },
  statIcon: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px'
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a2e',
    lineHeight: 1
  },
  statLabel: {
    fontSize: '13px',
    color: '#888',
    marginTop: '4px'
  },
  tableCard: {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  tableHeader: {
    padding: '16px 20px',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    background: '#f5f5f5',
    borderRadius: '8px',
    padding: '8px 12px',
    gap: '8px'
  },
  searchInput: {
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '14px',
    width: '200px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    textAlign: 'left',
    padding: '14px 16px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#fafafa',
    borderBottom: '1px solid #f0f0f0'
  },
  td: {
    padding: '16px',
    borderBottom: '1px solid #f5f5f5',
    fontSize: '14px',
    color: '#333'
  },
  campaignName: {
    fontWeight: '600',
    color: '#1a1a2e',
    fontSize: '15px'
  },
  campaignMeta: {
    fontSize: '12px',
    color: '#888',
    marginTop: '2px'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  leadsCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  leadsProgress: {
    width: '60px',
    height: '6px',
    background: '#e0e0e0',
    borderRadius: '3px',
    overflow: 'hidden'
  },
  leadsProgressBar: {
    height: '100%',
    borderRadius: '3px',
    transition: 'width 0.3s'
  },
  leadsText: {
    fontWeight: '600',
    fontSize: '14px'
  },
  budgetText: {
    fontWeight: '600',
    color: '#00a843',
    fontSize: '15px'
  },
  actionBtn: {
    width: '36px',
    height: '36px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s'
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px'
  },
  emptyIcon: {
    fontSize: '64px',
    marginBottom: '16px'
  },
  emptyTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px'
  },
  emptyText: {
    fontSize: '14px',
    color: '#888',
    marginBottom: '24px'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px',
    gap: '16px'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #f0f0f0',
    borderTopColor: '#00c853',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};

// ============================================
// СЕКЦИЯ: Главный компонент
// ============================================
const CampaignsList = ({ campaignType }) => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  const LEAD_COST_EUR = 20;

  // ============================================
  // СЕКЦИЯ: Конфигурация
  // ============================================
  const typeConfig = {
    b2b: {
      title: '🎯 B2B Кампании',
      subtitle: 'AI-портреты для сотрудников',
      createPath: '/business/b2b/create',
      wizardPath: (id) => `/business/campaigns/${id}/flux`
    },
    brand: {
      title: '🎁 Brand Кампании',
      subtitle: 'Лидогенерация и привлечение клиентов',
      createPath: '/business/brand/create',
      wizardPath: (id) => `/business/brand/campaigns/${id}/wizard`
    }
  };

  const config = typeConfig[campaignType] || typeConfig.brand;

  // ============================================
  // СЕКЦИЯ: Загрузка данных
  // ============================================
  useEffect(() => {
    loadCampaigns();
  }, [campaignType]);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      let url = '/campaigns';
      if (campaignType === 'b2b') {
        url = '/campaigns?type=b2b';
      } else if (campaignType === 'brand') {
        url = '/campaigns?type=brand';
      }
      
      const response = await api.get(url);
      let data = response.data || [];
      
      if (campaignType === 'brand') {
        data = data.filter(c => 
          c.type === 'brand' || 
          (c.campaign_type && c.campaign_type.startsWith('brand_'))
        );
      }
      
      setCampaigns(data);
    } catch (error) {
      console.error('Load campaigns error:', error);
    } finally {
      setLoading(false);
    }
  };

  // ============================================
  // СЕКЦИЯ: Вспомогательные функции
  // ============================================
  const getLeadCount = (campaign) => {
    return campaign.brand_config?.leadCount || campaign.brand_config?.giftCount || 0;
  };

  const getCurrentLeads = (campaign) => {
    // recipients_count содержит текущее кол-во активированных
    return parseInt(campaign.recipients_count || 0);
  };

  const getBudget = (campaign) => {
    const leads = getLeadCount(campaign);
    return leads * LEAD_COST_EUR;
  };

  const getStatusInfo = (campaign) => {
    const status = campaign.status;
    const currentLeads = getCurrentLeads(campaign);
    const targetLeads = getLeadCount(campaign);
    
    if (status === 'completed') {
      return { label: 'Завершена', color: '#00c853', bg: '#e8f5e9', icon: '✅' };
    }
    if (status === 'expired') {
      return { label: 'Истекла', color: '#ff9800', bg: '#fff3e0', icon: '⏰' };
    }
    if (status === 'ready') {
      if (currentLeads > 0 && currentLeads < targetLeads) {
        return { label: 'В работе', color: '#2196f3', bg: '#e3f2fd', icon: '🔄' };
      }
      return { label: 'Активна', color: '#00c853', bg: '#e8f5e9', icon: '🟢' };
    }
    if (status === 'generating') {
      return { label: 'Генерация', color: '#9c27b0', bg: '#f3e5f5', icon: '⚙️' };
    }
    if (status === 'draft') {
      return { label: 'Черновик', color: '#888', bg: '#f5f5f5', icon: '📝' };
    }
    return { label: status, color: '#888', bg: '#f5f5f5', icon: '📋' };
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
  };

  const canDelete = (status) => {
    return status !== 'completed';
  };

  // ============================================
  // СЕКЦИЯ: Действия
  // ============================================
  const openCampaign = (campaign) => {
    if (campaign.type === 'b2b' || campaign.campaign_type === 'b2b') {
      navigate(`/business/campaigns/${campaign.id}/flux`);
      return;
    }
    navigate(`/business/brand/campaigns/${campaign.id}/wizard`);
  };

  const deleteCampaign = async (e, campaignId, campaignName) => {
    e.stopPropagation();
    if (!window.confirm(`Удалить кампанию "${campaignName}"?\n\nНеиспользованные средства вернутся на баланс.`)) {
      return;
    }
    
    try {
      const response = await api.delete(`/campaigns/${campaignId}`);
      const refunded = response.data?.refunded || 0;
      alert(refunded > 0 
        ? `✅ Кампания удалена\n💰 Возвращено: €${parseFloat(refunded).toFixed(2)}`
        : '✅ Кампания удалена'
      );
      loadCampaigns();
    } catch (error) {
      alert(`❌ Ошибка: ${error.message}`);
    }
  };

  // ============================================
  // СЕКЦИЯ: Статистика
  // ============================================
  const stats = {
    total: campaigns.length,
    active: campaigns.filter(c => c.status === 'ready').length,
    completed: campaigns.filter(c => c.status === 'completed').length,
    draft: campaigns.filter(c => c.status === 'draft').length,
    totalBudget: campaigns.reduce((sum, c) => sum + getBudget(c), 0),
    totalLeads: campaigns.reduce((sum, c) => sum + getCurrentLeads(c), 0)
  };

  // ============================================
  // СЕКЦИЯ: Фильтрация
  // ============================================
  const filteredCampaigns = campaigns.filter(c => {
    if (filter === 'active') return c.status === 'ready';
    if (filter === 'completed') return c.status === 'completed';
    if (filter === 'draft') return c.status === 'draft';
    return true;
  }).filter(c => 
    !search || c.name?.toLowerCase().includes(search.toLowerCase())
  ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  // ============================================
  // СЕКЦИЯ: Loading State
  // ============================================
  if (loading) {
    return (
      <div style={styles.page}>
        <div style={styles.loading}>
          <div style={styles.spinner}></div>
          <p style={{ color: '#888' }}>Загрузка кампаний...</p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // ============================================
  // СЕКЦИЯ: Рендер
  // ============================================
  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerInfo}>
          <h1 style={styles.title}>{config.title}</h1>
          <p style={styles.subtitle}>{config.subtitle}</p>
        </div>
        <div style={styles.headerActions}>
          <button style={styles.btnRefresh} onClick={loadCampaigns}>
            🔄 Обновить
          </button>
          <button style={styles.btnCreate} onClick={() => navigate(config.createPath)}>
            <span style={{ fontSize: '18px' }}>+</span> Создать кампанию
          </button>
        </div>
      </div>

      {/* Stats Row */}
      <div style={styles.statsRow}>
        <div 
          style={{ ...styles.statCard, ...(filter === 'all' ? styles.statCardActive : {}) }}
          onClick={() => setFilter('all')}
        >
          <div style={{ ...styles.statIcon, background: '#e3f2fd' }}>📊</div>
          <div>
            <div style={styles.statValue}>{stats.total}</div>
            <div style={styles.statLabel}>Всего кампаний</div>
          </div>
        </div>
        
        <div 
          style={{ ...styles.statCard, ...(filter === 'active' ? styles.statCardActive : {}) }}
          onClick={() => setFilter('active')}
        >
          <div style={{ ...styles.statIcon, background: '#e8f5e9' }}>🟢</div>
          <div>
            <div style={styles.statValue}>{stats.active}</div>
            <div style={styles.statLabel}>Активных</div>
          </div>
        </div>

        <div 
          style={{ ...styles.statCard, ...(filter === 'completed' ? styles.statCardActive : {}) }}
          onClick={() => setFilter('completed')}
        >
          <div style={{ ...styles.statIcon, background: '#fff3e0' }}>✅</div>
          <div>
            <div style={styles.statValue}>{stats.completed}</div>
            <div style={styles.statLabel}>Завершённых</div>
          </div>
        </div>

        <div style={styles.statCard}>
          <div style={{ ...styles.statIcon, background: '#fce4ec' }}>👥</div>
          <div>
            <div style={styles.statValue}>{stats.totalLeads}</div>
            <div style={styles.statLabel}>Всего лидов</div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div style={styles.tableCard}>
        <div style={styles.tableHeader}>
          <div style={styles.searchBox}>
            <span>🔍</span>
            <input 
              style={styles.searchInput}
              placeholder="Поиск..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <span style={{ color: '#888', fontSize: '14px' }}>
            Найдено: {filteredCampaigns.length}
          </span>
        </div>

        {filteredCampaigns.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>🚀</div>
            <div style={styles.emptyTitle}>
              {campaigns.length === 0 ? 'Создайте первую кампанию' : 'Ничего не найдено'}
            </div>
            <div style={styles.emptyText}>
              {campaigns.length === 0 
                ? 'Привлекайте клиентов с помощью AI-подарков и получайте качественные лиды'
                : 'Попробуйте изменить параметры поиска'}
            </div>
            {campaigns.length === 0 && (
              <button style={styles.btnCreate} onClick={() => navigate(config.createPath)}>
                + Создать кампанию
              </button>
            )}
          </div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Кампания</th>
                <th style={{ ...styles.th, textAlign: 'center' }}>Лиды</th>
                <th style={styles.th}>Бюджет</th>
                <th style={styles.th}>Статус</th>
                <th style={styles.th}>Дата</th>
                <th style={{ ...styles.th, textAlign: 'center' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredCampaigns.map(campaign => {
                const statusInfo = getStatusInfo(campaign);
                const targetLeads = getLeadCount(campaign);
                const currentLeads = getCurrentLeads(campaign);
                const budget = getBudget(campaign);
                const progress = targetLeads > 0 ? (currentLeads / targetLeads) * 100 : 0;
                const progressColor = progress >= 100 ? '#00c853' : progress > 50 ? '#2196f3' : '#ff9800';
                
                return (
                  <tr 
                    key={campaign.id} 
                    onClick={() => openCampaign(campaign)}
                    style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f9f9f9'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <td style={styles.td}>
                      <div style={styles.campaignName}>{campaign.name || 'Без названия'}</div>
                      <div style={styles.campaignMeta}>
                        {campaign.brand_config?.brandName || 'Brand Campaign'}
                      </div>
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <div style={styles.leadsCell}>
                        <div style={styles.leadsProgress}>
                          <div style={{
                            ...styles.leadsProgressBar,
                            width: `${Math.min(progress, 100)}%`,
                            background: progressColor
                          }}></div>
                        </div>
                        <span style={styles.leadsText}>
                          {currentLeads}/{targetLeads}
                        </span>
                      </div>
                    </td>
                    <td style={styles.td}>
                      <span style={styles.budgetText}>€{budget.toFixed(2)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{
                        ...styles.badge,
                        color: statusInfo.color,
                        background: statusInfo.bg
                      }}>
                        {statusInfo.icon} {statusInfo.label}
                      </span>
                    </td>
                    <td style={styles.td}>
                      {formatDate(campaign.created_at)}
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <button 
                        style={{ ...styles.actionBtn, background: '#e3f2fd', color: '#1976d2' }}
                        onClick={(e) => { e.stopPropagation(); openCampaign(campaign); }}
                        title="Открыть"
                      >
                        📊
                      </button>
                      {canDelete(campaign.status) && (
                        <button 
                          style={{ ...styles.actionBtn, background: '#ffebee', color: '#d32f2f', marginLeft: '8px' }}
                          onClick={(e) => deleteCampaign(e, campaign.id, campaign.name)}
                          title="Удалить"
                        >
                          🗑️
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CampaignsList;